import React, { useEffect, useState } from 'react';
import { host_url } from '../../App'; // Import host_url
import '../ListenSubpage.css';
import '../../styles/CiTable.css';
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';

function SelbststaendigkeitAuslesen() {
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    fetch(`${host_url}/selbststaendigkeit`)
      .then(response => response.json())
      .then(data => setEntries(data))
      .catch(error => console.error('Error fetching Selbststaendigkeit entries:', error));
  }, []);

  const handlePrint = () => {
    window.print();
  };

  return (
    <KernteamLayout>
    <div className="container">
      <BackArrow to="/listen" />
      <h1 className="section-title blue">Anträge auf Selbstständigkeit</h1>
        <div className="table-header">
          <span className="print-link no-print" onClick={handlePrint}>
            <span className="material-symbols-outlined">print</span>
            <span className="print-text">Drucken</span>
          </span>
        </div>
      {entries.map(entry => (
        <div key={entry.ID} className="ci-table-wrapper">
        <table className="ci-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Antrag</th>
              <th>Zelt/Bereich</th>
              <th>Bearbeitet</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{entry.Name}</td>
              <td>{entry.Antrag}</td>
              <td>{entry['Zelt/Bereich']}</td>
              <td>{entry.bearbeitet ? 'Ja' : 'Nein'}</td>
            </tr>
          </tbody>
        </table>
        </div>
      ))}
    </div>
    </KernteamLayout>
  );
}

export default SelbststaendigkeitAuslesen;